import { apiService } from "api/apiService";
import type {
  MyLessongroupsActionplansCounts200,
  FilterResource,
  TeacherActionplanBatchResource,
} from "api/generated";
import { mapPaginatedResponse } from "api/mappers/pagination.mapper";
import type { PaginatedResponse, PaginatedResult } from "api/types";
import { actionplanBatchFromDto } from "actionplan/api/mappers";
import type { ActionplanBatch, ActionplanTabCounts } from "actionplan/types";
import { mapFilters } from "shared/mappers";
import type { Filter } from "shared/types";

export const fetchLessonClassActionplans = async (
  scheduleId: string,
  params: Record<string, string> = {},
): Promise<PaginatedResult<ActionplanBatch>> => {
  const { data } = await apiService.get<
    PaginatedResponse<TeacherActionplanBatchResource>
  >(`api/my-lessongroups/${encodeURIComponent(scheduleId)}/actionplans`, {
    params,
  });

  return mapPaginatedResponse(data, actionplanBatchFromDto);
};

export const fetchLessonClassActionplanCounts = async (
  scheduleId: string,
  params: Record<string, string> = {},
): Promise<ActionplanTabCounts> => {
  const { data } = await apiService.get<MyLessongroupsActionplansCounts200>(
    `api/my-lessongroups/${encodeURIComponent(scheduleId)}/actionplans/counts`,
    { params },
  );

  return data;
};

export const fetchLessonClassActionplanFilters = async (
  scheduleId: string,
): Promise<Filter[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    `api/my-lessongroups/${encodeURIComponent(scheduleId)}/actionplans/filters`,
  );

  return mapFilters(filters);
};
